var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-container clickable",on:{"click":_vm.copyCodeToClipboard}},[_c('a',{staticClass:"code-container__copy btn btn-function btn-xs"},[_c('CIcon',{attrs:{"name":"cil-copy"}})],1),_c('pre',{staticClass:"code-container__code"},[_c('code',[_vm._v(_vm._s(_vm.codeText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }